/* eslint-disable sort-keys-fix/sort-keys-fix */
const NodeTypes = {
    ORGANISATION: "organisation",
    SUBORGANISATION: "subOrganisation",
    PROJECT: "project",
    JOBFUNCTION: "jobFunction",
};

export default NodeTypes;
